import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as organizations from '../../../organizations'
import * as records from '../../records'
import type { TypeParams } from '../types'

/**
 * When a bulk responsible persons update is started, sets the department
 * filter to the departments the selected records are occupied by, so the user
 * only sees those in the department filter dropdown.
 */
export const setRecordDepartmentFilterOnBulkSessionStart = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: ec.Collection<TypeParams>,
    recordsEc: records.Collection,
  ) =>
    recordsEc.plugins
      .lookup(records.plugins.bulkResponsiblePersons.Plugin)
      .get()
      .actions.initiate.observe()
      .pipe(
        rxjsUtils.delayUntil(
          collection.plugins.currentListPlugin.appliedParams.initialized$,
        ),
        rxjs.withLatestFrom(
          recordsEc.plugins.selectionPlugin.feature.selectors.getAllSelected({
            target: records.SPACE_RECORDS_SELECTION_TARGET,
          }).asObservable,
        ),
        rxjs.map(([, selectedRecords]) => {
          const occupierOrgIds = [
            ...new Set(
              selectedRecords
                .filter(TypeChecker.isNotNullish.raw)
                .map(({ occupierId }) => occupierId)
                .filter(TypeChecker.isNotNullish.raw),
            ),
          ]

          return collection.plugins.currentListPlugin.appliedParams.actions.writeAllProperties
            .from('setRecordDepartmentFilterOnBulkSessionStart (effect)')
            .create({
              values: {
                filters: {
                  orgFilter: occupierOrgIds.length
                    ? {
                        entityId: organizations.constants.DEPARTMENT_ENTITY_ID,
                        recordIds: occupierOrgIds,
                      }
                    : undefined,
                },
              },
            })
        }),
      ),
)
